import { Input, InputNumber } from 'antd'
import type { InputProps } from 'antd/es/input'
import type { InputNumberProps } from 'antd/es/input-number'
import type { PasswordProps } from 'antd/es/input/Password'
import type { SearchProps } from 'antd/es/input/Search'
import type { TextAreaProps } from 'antd/es/input/TextArea'
import type React from 'react'
import { forwardRef } from 'react'

type InputType = 'textarea' | 'number' | 'search' | 'password' | 'otp' | 'default'

type CommonProps = {
  label?: string
  type?: InputType
  floating?: boolean
  className?: string
  /** Điểm bám cho e2e. Không truyền thì không render attribute nào. */
  testId?: string
}

type InputCustomProps =
  | (CommonProps & InputProps & { type?: 'default' | undefined })
  | (CommonProps & TextAreaProps & { type: 'textarea' })
  | (CommonProps & PasswordProps & { type: 'password' })
  | (CommonProps & SearchProps & { type: 'search' })
  | (CommonProps & InputNumberProps & { type: 'number' })
  | (CommonProps & Record<string, unknown> & { type: 'otp' })

const InputCustom = forwardRef<React.ElementRef<typeof Input>, InputCustomProps>((props, ref) => {
  const {
    label = '',
    type = 'default',
    floating = false,
    className = '',
    testId,
    ...restProps
  } = props
  const rest: Record<string, unknown> = {
    ...(restProps as Record<string, unknown>),
    'data-testid': testId,
  }

  const typeMap: Record<string, unknown> = {
    textarea: Input.TextArea,
    number: InputNumber,
    search: Input.Search,
    password: Input.Password,
    otp: (Input as unknown as Record<string, React.ElementType>).OTP, // nếu có
    default: Input,
  }

  const Component = (typeMap[type as string] || Input) as React.ElementType
  let style: React.CSSProperties = (rest.style as React.CSSProperties) || {}

  if (type === 'textarea') {
    style = {
      ...style,
      minHeight: '80px',
      overflowX: 'hidden',
      overflowY: 'auto', // hoặc 'hidden' tùy nhu cầu
    }
  } else if (type === 'number') {
    style = { ...style, width: '100%' }
  }

  return (
    // chuyển tiếp ref xuống component antd tương ứng
    <Component
      ref={ref}
      placeholder={label}
      className={`${floating ? 'floating-label' : ''} ${className}`}
      {...(type === 'search' ? { enterButton: true } : {})}
      {...rest}
      style={style}
    />
  )
})

InputCustom.displayName = 'InputCustom'
export default InputCustom
